import { useIntl } from 'react-intl';

import { messages } from './messages';
import { IUseCheckUserRefundEligibilityReturn } from './types';
import { useCheckUserRefundsCount } from './use-check-user-refunds-count';

/**
 * Determine's whether the logged in user is eligible for a refund,
 * and, if not, why.
 */
export const useCheckUserRefundEligibility = (): IUseCheckUserRefundEligibilityReturn => {
  const { formatMessage } = useIntl();

  const { areTotalRefundsWithinLimit, loading } = useCheckUserRefundsCount();

  const refundExceedsLimitsText =
    !areTotalRefundsWithinLimit && formatMessage(messages.supportFormRefundGenericError);

  return {
    isUserEligibleForRefund: areTotalRefundsWithinLimit,
    areTotalRefundsWithinLimit,
    refundIneligibilityReason: refundExceedsLimitsText,
    loading
  };
};
